module.exports = __webpack_public_path__ + "fonts/Inter-300-latin-ext20.1ad231a.woff2";